import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Grid,
  Typography,
  Card,
  CardContent,
  Skeleton,
  Box,
  Button,
  Alert,
  CardHeader,
} from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import IconButton from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import FormLabel from '@mui/material/FormLabel';
import makeStyles from '@mui/styles/makeStyles';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import { ArrowCircleUp } from '@mui/icons-material';
import TagList from '../../../../../../../components/TagList';
import TaskDefinitionAutocomplete from '../../../../../../../components/Autocompletes/TaskDefinition';
import styles from './styles';

const useStyles = makeStyles(styles);

export const DataFormComponent = (props) => {
  const classes = useStyles();
  const {
    eventTemplate,
    handleChangeChildren,
    isLoading,
    navigate,
  } = props;

  const label = (
    <Grid item xs={12} md={3} lg={2}>
      <Typography variant="subtitle2">Calendar Type Tasks</Typography>
      <Typography variant="caption" gutterBottom>
        Define any tasks available to be created and associated with this
        calendar event.
      </Typography>
    </Grid>
  );

  if (isLoading) {
    return (
      <Grid container spacing={4}>
        {label}
        <Grid item xs={12} md={9} lg={10} container className={classes.section}>
          <Card className={classes.card}>
            <CardContent>
              <Skeleton className={classes.nameField} />
              <Skeleton />
              <Skeleton />
              <Skeleton />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={4}>
      {label}
      <Grid item xs={12} md={9} lg={10} container className={classes.section}>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card className={classes.card}>
              <CardHeader
                title="Associated & Available Tasks"
                subheader="Tasks selected below will be available when scheduling calendar events of this type."
                sx={{ pb: 0 }}
              />
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <TaskDefinitionAutocomplete
                      label="Select Tasks To Associated"
                      startAdornmentIcon={<AddIcon />}
                      eventTemplates={null} // needs to be null so component uses all templates
                      onSelect={(e, taskDefinition) => {
                        handleChangeChildren([...eventTemplate.children, taskDefinition]);
                      }}
                      exludeTagIds={[...eventTemplate.children.map((et) => et.id)]}
                      includeEventTaskTypeTagId={false}
                    />
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mt: 1,
                      }}
                    >
                      <ArrowCircleUp color="secondary" />
                      <Typography
                        sx={{
                          fontWeight: 300,
                          fontSize: 14,
                          ml: 1,
                        }}
                      >
                        Search for task above to associate it with this calendar type
                      </Typography>
                    </Box>

                    <Alert severity="info" sx={{ mt: 4 }}>
                      <Grid container justifyContent="space-between">
                        <Grid
                          item
                          xs={12}
                        >
                          Tasks are optional when scheduling a calendar event. If you do want to schedule tasks with your calendar event
                          you must specify which tasks are available to a be associated with the type of calendar event.
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            justifyContent: 'flex-end',
                            mt: 1,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{ mr: 1 }}
                          >Don&#39;t see the right task type in the list?
                          </Typography>
                          <Button sx={{ py: 0 }} size="small" onClick={() => { if (navigate) { navigate('/settings/tasks') } else { window.location.href = '/settings/tasks' } }}>
                            Manage Task Types
                          </Button>
                        </Grid>
                      </Grid>
                    </Alert>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl
                      sx={{ m: 0 }}
                      fullWidth
                      variant="outlined"
                    >
                      <FormLabel id="board-display-radio-buttons-group-label">Selected & Available Tasks</FormLabel>
                      {
                    eventTemplate.children && eventTemplate.children.length === 0 && (
                      <Alert severity="warning" variant="outlined" sx={{ pt: 0 }}>
                        No tasks currently associated with this calendar type
                      </Alert>
                    )
                  }
                      <List sx={{ py: 0 }}>
                        {eventTemplate.children.map((et) => (
                          <ListItem
                            button
                            divider
                            dense
                            key={`task-child-${et.id}`}
                            secondaryAction={(
                              <IconButton edge="end" aria-label="delete" onClick={() => handleChangeChildren(eventTemplate.children.filter((fet) => fet.id !== et.id))}>
                                <DeleteIcon />
                              </IconButton>
                            )}
                          >
                            <ListItemText
                              primary={et.name}
                              secondaryTypographyProps={{ component: 'div' }}
                              secondary={(
                                <Box>
                                  <TagList tags={et.tags} size="small" />
                                  <div>{et.description}</div>
                                </Box>
                              )}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </FormControl>

                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          {/* <Grid item xs={12} md={6}>
            {
              eventTemplate.children && eventTemplate.children.length > 0 && (
                <Card className={classes.card}>
                  <CardHeader
                    title={(
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >Track Task Completion Time <Switch
                        checked={!!(eventTemplate.dueDateDefaultTime && eventTemplate.dueDateDefaultTime > 0)}
                        onChange={(event) => {
                          if (event.target.checked) {
                            handleDueDateChange(0, 2, 0);
                          } else {
                            handleDueDateChange(0, 0, 0);
                          }
                        }}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                      </Box>
                    )}
                    subheader="If turned on, Questri will track and measure the amount of
                    time the task should be completed in from when it is started/created.
                    If a task is not marked complete by a user in the specified time limit, the task moves into a 'Past Due' state."
                    sx={{ pb: 0 }}
                  />
                  <CardContent>
                    <Grid container spacing={4}>
                      <Grid
                        item
                        xs={12}
                        md={(eventTemplate.dueDateDefaultTime
                          && eventTemplate.dueDateDefaultTime > 0 && !eventTemplate.dueDateDefaultTimeEndOfDay)
                          ? 6
                          : 12}
                      >
                        <FormGroup>
                          {
                            (eventTemplate.dueDateDefaultTime && eventTemplate.dueDateDefaultTime > 0)
                              ? (
                                <>
                                  <FormControlLabel
                                    sx={{ mb: 0 }}
                                    value={!!eventTemplate.dueDateDefaultTimeEndOfDay}
                                    control={<Switch />}
                                    checked={!!eventTemplate.dueDateDefaultTimeEndOfDay}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        handleChangeDueDateDefaultTime(1, true)
                                      } else {
                                        handleDueDateChange(0, 12, 0)
                                      }
                                    }}
                                    label="Complete task by end of day"
                                  />
                                  <FormHelperText>
                                    If turned on, the task will enter the &#34;Past Due&#34;
                                    state if not completed by the end of the day in which is was created.
                                  </FormHelperText>
                                  <FormControlLabel
                                    sx={{
                                      mt: 2,
                                      mb: 0,
                                    }}
                                    control={<Switch />}
                                    label="Automatically complete task when task reaches 'Past Due' state"
                                    checked={!!eventTemplate.dueDateStatusChangeId}
                                    onChange={(event) => {
                                      if (event.target.checked) {
                                        handleChangeDateStatusChangeId(statusEndId);
                                      } else {
                                        handleChangeDateStatusChangeId(0);
                                      }
                                    }}
                                  />
                                  <FormHelperText>
                                    If turned on, Questri will automatically complete the task
                                    if the task completion time is exceeded and the task enters the &#34;Past Due&#34;
                                    state without being completed by a user.
                                  </FormHelperText>
                                </>
                              )
                              : <div />
                          }
                        </FormGroup>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={(eventTemplate.dueDateDefaultTime
                            && eventTemplate.dueDateDefaultTime > 0 && !eventTemplate.dueDateDefaultTimeEndOfDay)
                          ? 6
                          : 12}
                      >
                        {
                          (eventTemplate.dueDateDefaultTime && eventTemplate.dueDateDefaultTime > 0 && !eventTemplate.dueDateDefaultTimeEndOfDay)
                            ? (
                              <>
                                <FormControl variant="outlined" className={classes.defaultDueDateTimeInput}>
                                  <OutlinedInput
                                    label=" "
                                    id="default-due-date-days"
                                    type="number"
                                    margin="dense"
                                    value={defaultDueDateDays}
                                    onChange={(e) => { handleDueDateChange(e.target.value, defaultDueDateHours, defaultDueDateMinutes); }}
                                    endAdornment={<InputAdornment position="end">days</InputAdornment>}
                                  />
                                </FormControl>
                                <FormControl variant="outlined" className={classes.defaultDueDateTimeInput}>
                                  <OutlinedInput
                                    label=" "
                                    id="default-due-date-hours"
                                    type="number"
                                    margin="dense"
                                    value={defaultDueDateHours}
                                    onChange={(e) => { handleDueDateChange(defaultDueDateDays, e.target.value, defaultDueDateMinutes); }}
                                    endAdornment={<InputAdornment position="end">hours</InputAdornment>}
                                  />
                                </FormControl>
                                <FormControl variant="outlined" className={classes.defaultDueDateTimeInput}>
                                  <OutlinedInput
                                    label=" "
                                    id="default-due-date-minutes"
                                    type="number"
                                    margin="dense"
                                    value={defaultDueDateMinutes}
                                    onChange={(e) => { handleDueDateChange(defaultDueDateDays, defaultDueDateHours, e.target.value); }}
                                    endAdornment={<InputAdornment position="end">minutes</InputAdornment>}
                                  />
                                </FormControl>
                              </>
                            )
                            : <div />
                        }
                        {
                          (eventTemplate.dueDateDefaultTime && eventTemplate.dueDateDefaultTime > 0 && !eventTemplate.dueDateDefaultTimeEndOfDay)
                            ? (
                              <FormControl fullWidth component="fieldset" className={classes.dueDateWorkingTimeFormControl}>
                                <FormLabel>Total time (days, hours, minutes) the task must be completed in
                                  before being &#34;Past Due&#34;
                                </FormLabel>
                                <FormGroup row>
                                  <FormControlLabel
                                    control={<Checkbox checked={!eventTemplate.dueDateWorkingTime ||
                                       eventTemplate.dueDateWorkingTime.MONDAY !== false} onChange={handleDueDateWorkingTimeChange} name="MONDAY" />}
                                    label="Mon"
                                  />
                                  <FormControlLabel
                                    control={<Checkbox checked={!eventTemplate.dueDateWorkingTime ||
                                       eventTemplate.dueDateWorkingTime.TUESDAY !== false}
                                       onChange={handleDueDateWorkingTimeChange} name="TUESDAY" />}
                                    label="Tue"
                                  />
                                  <FormControlLabel
                                    control={<Checkbox checked={!eventTemplate.dueDateWorkingTime ||
                                      !eventTemplate.dueDateWorkingTime.WEDNESDAY !== false}
                                      onChange={handleDueDateWorkingTimeChange} name="WEDNESDAY" />}
                                    label="Wed"
                                  />
                                  <FormControlLabel
                                    control={<Checkbox checked={!eventTemplate.dueDateWorkingTime ||
                                      eventTemplate.dueDateWorkingTime.THURSDAY !== false}
                                      onChange={handleDueDateWorkingTimeChange} name="THURSDAY" />}
                                    label="Thu"
                                  />
                                  <FormControlLabel
                                    control={<Checkbox checked={!eventTemplate.dueDateWorkingTime ||
                                      eventTemplate.dueDateWorkingTime.FRIDAY !== false} onChange={handleDueDateWorkingTimeChange} name="FRIDAY" />}
                                    label="Fri"
                                  />
                                  <FormControlLabel
                                    control={<Checkbox checked={!eventTemplate.dueDateWorkingTime ||
                                      eventTemplate.dueDateWorkingTime.SATURDAY !== false}
                                      onChange={handleDueDateWorkingTimeChange} name="SATURDAY" />}
                                    label="Sat"
                                  />
                                  <FormControlLabel
                                    control={<Checkbox checked={!eventTemplate.dueDateWorkingTime ||
                                       eventTemplate.dueDateWorkingTime.SUNDAY !== false} onChange={handleDueDateWorkingTimeChange} name="SUNDAY" />}
                                    label="Sun"
                                  />
                                </FormGroup>
                                <FormHelperText>Select or deselect days you do not want included the the time calculation.
                                  Helpful when you have non working days.
                                </FormHelperText>
                              </FormControl>
                            )
                            : <div />
                        }
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              )
            }
          </Grid> */}
        </Grid>

      </Grid>
    </Grid>
  );
};

DataFormComponent.propTypes = {
  eventTemplate: PropTypes.object,
  handleChangeChildren: PropTypes.func,
  isLoading: PropTypes.bool,
  navigate: PropTypes.func,
};

DataFormComponent.defaultProps = {
  eventTemplate: {},
  handleChangeChildren: () => {},
  isLoading: true,
  navigate: null,
};

export default DataFormComponent;
